import { render, staticRenderFns } from "./settlement-pay-record.vue?vue&type=template&id=3e936984&scoped=true&"
import script from "./settlement-pay-record.vue?vue&type=script&lang=js&"
export * from "./settlement-pay-record.vue?vue&type=script&lang=js&"
import style0 from "./settlement-pay-record.vue?vue&type=style&index=0&id=3e936984&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e936984",
  null
  
)

export default component.exports